let mm = gsap.matchMedia();
//inview item
const ivItems = gsap.utils.toArray('.iv-item');
ivItems.forEach(ivItem => {
	ScrollTrigger.create({
		trigger: ivItem,
		start: 'top 90%',
		force3D: true,
		toggleClass: { targets: ivItem, className: 'iv-item--is-active' },
		// once: true,
		refreshPriority: 0,
	});
});
// gsap.to('.page-section--concept', {
// 	clipPath: 'circle(150% at 50% 50%)',
// 	ease: 'none',
// 	scrollTrigger: {
// 		trigger: '.page-section--concept',
// 		start: 'top top',
// 		end: '+=100%',
// 		scrub: 1,
// 		pin: true,
// 		anticipatePin: 1
// 	}
// });
gsap.to('.page-section--intro', {
	opacity: 0,
	ease: 'none',
	scrollTrigger: {
		trigger: '.page-section--concept',
		start: 'top bottom', 
		end: 'top center', 
		scrub: 1,
	}
});
gsap.to('.page-section--concept', {
	clipPath: 'circle(150% at 50% 50%)',
	ease: 'none',
	scrollTrigger: {
		trigger: '.page-section--concept',
		// コンセプトの「上」が 画面の「上」に来た瞬間にピン留め
		start: 'top top', 
		// 100vh分（画面1枚分）スクロールする間、その場に固定して円を広げる
		end: '+=150%', 
		scrub: 1,
		pin: true,
		pinSpacing: true, // 次のコンテンツを下に押し下げる
	}
});
ScrollTrigger.create({
	trigger: '.page-section--concept',
	start: 'bottom 90%', 
	onEnter: () => document.body.classList.add('is-end'),
	onLeaveBack: () => document.body.classList.remove('is-end'),
});